import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-m-small', 'IconLetterMSmall', [
  ['path', { d: 'M9 16v-8l3 5l3 -5v8', key: 'svg-0' }],
]);
